var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHelp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 0C5.38293 0 0 5.38293 0 12C0 18.6171 5.38293 24 12 24C18.6171 24 24 18.6171 24 12C24 5.38293 18.6171 0 12 0ZM12 18.9999C11.4479 18.9999 11.0001 18.5521 11.0001 18C11.0001 17.4479 11.4479 17.0001 12 17.0001C12.5521 17.0001 12.9999 17.4479 12.9999 18C12.9999 18.5521 12.5521 18.9999 12 18.9999ZM13.5829 12.642C13.229 12.8049 12.9999 13.162 12.9999 13.5511V14.0001C12.9999 14.5519 12.553 15 12 15C11.447 15 11.0001 14.5519 11.0001 14.0001V13.5511C11.0001 12.384 11.686 11.3141 12.7451 10.825C13.764 10.3561 14.4999 9.11096 14.4999 8.49994C14.4999 7.12207 13.379 6 12 6C10.621 6 9.50006 7.12207 9.50006 8.49994C9.50006 9.052 9.05292 9.50006 8.49994 9.50006C7.94696 9.50006 7.5 9.052 7.5 8.49994C7.5 6.01904 9.51892 3.99994 12 3.99994C14.4811 3.99994 16.5 6.01904 16.5 8.49994C16.5 9.85107 15.3279 11.837 13.5829 12.642Z",
    fill: "#4D4D4D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp);
export default __webpack_public_path__ + "static/media/help.20e4cdbfa9fdcfac97a49592f4d6989d.svg";
export { ForwardRef as ReactComponent };